import { z } from 'zod';
import { userRoleSchema } from './user.schema';

// Request code schema (step 1: email only)
export const requestCodeSchema = z.object({
  email: z.string().email('Invalid email address'),
});

export type RequestCodeDto = z.infer<typeof requestCodeSchema>;

// Verify code schema (step 2: email + code)
export const verifyCodeSchema = z.object({
  email: z.string().email('Invalid email address'),
  code: z.string().min(8, 'Code must be 8 characters').max(8, 'Code must be 8 characters'),
});

export type VerifyCodeDto = z.infer<typeof verifyCodeSchema>;

// Password login schema
export const passwordLoginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
});

export type PasswordLoginDto = z.infer<typeof passwordLoginSchema>;

// Resend code schema
export const resendCodeSchema = z.object({
  email: z.string().email('Invalid email address'),
});

export type ResendCodeDto = z.infer<typeof resendCodeSchema>;

// Auth response schemas
export const authResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string().optional(),
  user: z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
    role: userRoleSchema,
    created_at: z.date().or(z.string().datetime()),
  }),
});

export type AuthResponse = z.infer<typeof authResponseSchema>;

// Refresh token schema
export const refreshTokenSchema = z.object({
  refreshToken: z.string(),
});

export type RefreshTokenDto = z.infer<typeof refreshTokenSchema>;

export const setPasswordSchema = z.object({
  password: z.string().min(8, 'Password must be at least 8 characters'),
});

export type SetPasswordDto = z.infer<typeof setPasswordSchema>;
